import { Map, List } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as apiKeysActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';

export const initialState = Map({
  keys: Map({
    data: Map(),
    records: List(),
    loading: false,
    total: 0,
    totalPages: 0
  }),
  creation: Map({
    loading: false,
    newApiKey: null,
    token: null,
    cert: null,
    certDer: null,
    privateKey: null,
  })
});

function resetState (state) {
  return state.withMutations((nextState) =>
    nextState.set('keys', Map({
      data: Map(),
      records: List(),
      loading: false,
      total: 0,
      totalPages: 0
    })).set('creation', Map({
      loading: false,
      newApiKey: null,
      token: null,
      cert: null,
      certDer: null,
      privateKey: null,
    }))
  );
}

export const apiKeysReducer = createTypedReducer(initialState, {

  [apiKeysActions.FETCH_API_KEYS] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['keys', 'loading'], true);
    });
  },

  [apiKeysActions.FETCH_API_KEYS_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const fetchDate = new Date();
      let newDataIds = List();
      nextState.setIn(['keys', 'data'], Map({}));
      action.keys.map((key) => {
        newDataIds = newDataIds.push(key.get('id'));
        nextState.setIn(['keys', 'data', key.get('id')], {
          record: key,
          lastFetch: fetchDate,
        });
      });
      nextState.setIn(['keys', 'records'], newDataIds);
      nextState.setIn(['keys', 'total'], action.total);
      nextState.setIn(['keys', 'totalPages'], action.totalPages);
      nextState.setIn(['keys', 'loading'], false);
    });
  },

  [apiKeysActions.FETCH_API_KEYS_FAILED] (state) {
    return state.withMutations((nextState) =>
      nextState.setIn(['keys', 'loading'], false)
    );
  },

  [apiKeysActions.DELETE_API_KEY_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      nextState = nextState.deleteIn(['keys', 'data', action.keyId]);
      const newIds = nextState.getIn(['keys', 'records'], []);
      nextState = nextState.setIn(['keys', 'records'], newIds.filter(x => x !== action.keyId));
      nextState.setIn(['keys', 'loading'], false);
      return nextState;
    });
  },

  [apiKeysActions.CREATE_API_KEY] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['creation', 'loading'], true);
      nextState.setIn(['creation', 'newApiKey'], null);
      nextState.setIn(['creation', 'token'], null);
      nextState.setIn(['creation', 'cert'], null);
      nextState.setIn(['creation', 'certDer'], null);
      nextState.setIn(['creation', 'privateKey'], null);
    });
  },

  [apiKeysActions.CREATE_API_KEY_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const fetchDate = new Date();
      const newApiKey = action.apiKey;

      // Add the new API key to the list
      const currentRecords = nextState.getIn(['keys', 'records'], List());
      nextState.setIn(['keys', 'data', newApiKey.get('id')], {
        record: newApiKey,
        lastFetch: fetchDate,
      });
      nextState.setIn(['keys', 'records'], currentRecords.push(newApiKey.get('id')));
      nextState.setIn(['keys', 'total'], nextState.getIn(['keys', 'total'], 0) + 1);

      // Store the creation details
      nextState.setIn(['creation', 'loading'], false);
      nextState.setIn(['creation', 'newApiKey'], newApiKey);
      nextState.setIn(['creation', 'token'], action.token);
      nextState.setIn(['creation', 'cert'], action.cert);
      nextState.setIn(['creation', 'certDer'], action.certDer);
      nextState.setIn(['creation', 'privateKey'], action.privateKey);
    });
  },

  [apiKeysActions.CREATE_API_KEY_FAILED] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['creation', 'loading'], false);
      nextState.setIn(['creation', 'newApiKey'], null);
      nextState.setIn(['creation', 'token'], null);
      nextState.setIn(['creation', 'cert'], null);
      nextState.setIn(['creation', 'certDer'], null);
      nextState.setIn(['creation', 'privateKey'], null);
    });
  },

  [apiKeysActions.CLEAR_API_KEY_TOKEN] (state) {
    return state.withMutations((nextState) => {
      nextState.setIn(['creation', 'token'], null);
      nextState.setIn(['creation', 'cert'], null);
      nextState.setIn(['creation', 'certDer'], null);
      nextState.setIn(['creation', 'privateKey'], null);
      nextState.setIn(['creation', 'newApiKey'], null);
    });
  },

  [apiKeysActions.UPDATE_API_KEY_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const fetchDate = new Date();
      const updatedApiKey = action.apiKey;
      const apiKeyId = updatedApiKey.get('id');

      // Update the API key in the data store
      if (nextState.hasIn(['keys', 'data', apiKeyId])) {
        nextState.setIn(['keys', 'data', apiKeyId], {
          record: updatedApiKey,
          lastFetch: fetchDate,
        });
      }
    });
  },

  [apiKeysActions.UPDATE_API_KEY_FAILED] (state) {
    return state;
  },

  [CLEAR] (state) {
    return resetState(state);
  },

  [CHANGE_CLIENT] (state) {
    return resetState(state);
  }
});

export default apiKeysReducer;
